import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { setupGlobalErrorHandlers } from "./utils/errorHandler";

// Setup global error handlers to suppress harmless errors like ResizeObserver loop errors
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
